<template>
  <div>
    <router-view v-if="inited"/>
    <div
      v-if="$store.state.page.loading && !$store.state.page.isProcessLoading"
      :id="utils.getIds('common', 'pls_wait_icon')"
      class="el-loading-mask"
    >
      <div id="wait_img" class="dni-page-loading" v-if="inited">
        <div id="wait_text">{{ $t("wizard_pls_wait") }}</div>
        <img src="~images/wizard/wait.gif" />
      </div>
    </div>
    <div
      v-if="$store.state.page.loading && $store.state.page.isProcessLoading"
      class="el-loading-process"
      :class="$store.state.page.loadingClass"
    >
      <div id="prgbar1">
        <div id="process" :style="{ width: $store.state.page.process + '%' }"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inited: false,
    };
  },
  async beforeCreate() {
    const ret = await this.$store.dispatch("user/getinfo");
    if (ret && (ret.code == 0 || ret.code == 7)) {
      this.inited = true;
    }
  },
};
</script>